import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { Card, LysaLink, Snackbar, SNACKBAR_TYPES, Spinner, } from "@lysaab/ui-2";
import { getSignupInfo } from "../../data/signup";
import { matchPath } from "react-router";
import "./OnfidoStatusPage.scss";
import { useParams } from "react-router-dom";
import { LysaCountry } from "@lysaab/shared";
function getLinkPrefix(pathname = window.location.pathname) {
    var _a;
    const match = matchPath(pathname, {
        path: "/:country",
    });
    const country = (_a = match === null || match === void 0 ? void 0 : match.params.country) !== null && _a !== void 0 ? _a : "";
    if (Object.values(LysaCountry).includes(country.toUpperCase())) {
        return country;
    }
    return "";
}
export const SignupInfo = () => {
    const [signupData, setSignupData] = useState();
    const { signupId } = useParams();
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        getSignupInfo(signupId)
            .then((response) => {
            setSignupData(response);
        })
            .catch((error) => {
            console.error(error);
        })
            .finally(() => {
            setLoading(false);
        });
    }, [signupId]);
    const restartLink = new URL(getLinkPrefix(), window.location.origin).toString();
    return (React.createElement("div", { className: "signup-info" },
        React.createElement(Card, null,
            React.createElement("h3", null,
                React.createElement(FormattedMessage, { id: "onfido.signup_info.header" })),
            loading && React.createElement(Spinner, null),
            !loading && !signupData && (React.createElement("div", { className: "info" },
                React.createElement(FormattedMessage, { id: "onfido.signup_info.no_signup_data", values: {
                        link: (chunks) => (React.createElement(LysaLink, { href: restartLink }, chunks)),
                    } }))),
            !loading && signupData && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "info" },
                    React.createElement("p", null, signupData === null || signupData === void 0 ? void 0 :
                        signupData.firstName,
                        " ", signupData === null || signupData === void 0 ? void 0 :
                        signupData.lastName),
                    React.createElement("p", null, signupData === null || signupData === void 0 ? void 0 : signupData.dateOfBirth),
                    React.createElement("p", null, signupData === null || signupData === void 0 ? void 0 : signupData.street),
                    React.createElement("p", null, signupData === null || signupData === void 0 ? void 0 :
                        signupData.postalCode,
                        " ", signupData === null || signupData === void 0 ? void 0 :
                        signupData.city),
                    React.createElement("p", null, signupData === null || signupData === void 0 ? void 0 : signupData.residentCountry)),
                React.createElement(Snackbar, { type: SNACKBAR_TYPES.INFO },
                    React.createElement(FormattedMessage, { id: "onfido.signup_info.info", values: {
                            link: (chunks) => (React.createElement(LysaLink, { href: restartLink }, chunks)),
                        } })))))));
};
